import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgTf = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="flag-icons-tf"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <path id="tf-a" fill="#fff" d="m0-21 12.3 38L-20-6.5h40L-12.3 17z" />
    </defs>
    <path fill="#002395" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 0h292.8v196.8H0z" />
    <path fill="#002395" d="M0 0h96v192H0z" />
    <path fill="#ed2939" d="M192 0h96v192h-96z" />
    <path
      fill="#fff"
      d="m426 219.6 15.4 24.6h44V330l-33-51.6-44.4 70.8h21.6l22.8-40.8 46.8 84 46.8-84 22.8 40.8h21.6L546 278.4 513 330v-47.4h19.8l14.7-23.4H513v-15h44l15.4-24.6zm51.6 105h-48v16.8h48zm91.2 0h-48v16.8h48z"
    />
    <use
      xlinkHref="#tf-a"
      width="100%"
      height="100%"
      x={416}
      y={362}
      transform="scale(1.2)"
    />
    <use
      xlinkHref="#tf-a"
      width="100%"
      height="100%"
      x={371}
      y={328}
      transform="scale(1.2)"
    />
    <use
      xlinkHref="#tf-a"
      width="100%"
      height="100%"
      x={461}
      y={328}
      transform="scale(1.2)"
    />
    <use
      xlinkHref="#tf-a"
      width="100%"
      height="100%"
      x={333}
      y={227}
      transform="scale(1.2)"
    />
    <use
      xlinkHref="#tf-a"
      width="100%"
      height="100%"
      x={499}
      y={227}
      transform="scale(1.2)"
    />
  </svg>
);
export default SvgTf;
